import { set } from "lodash";
import { useEffect, useMemo, useRef, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";

const useTodasMicroRegioes = (todosOsClientes = [], config = {}) => {
  const { salvarLocalStorage = false, chave } = config;
  const [microRegioes, setMicroRegioes] = useState([]);
  const [microRegiao, setMicroRegiao] = useState("");
  const [onMicroRegiao, setOnMicroRegiao] = useState(false);
  const microRegiaoSelect = useSelect("microRegioes");
  const [selectMicro, setSelectMicro] = useState(null);
  const restoredMicroRef = useRef(false);

  useEffect(() => {
    const fetchMicroRegioes = (clientes) => {
      const microMap = new Map();

      clientes.forEach((cliente) => {
        const nome = cliente?.microrregiao;
        const mesoId = cliente?.microrregiaoId;

        if (nome) {
          microMap.set(nome, { nome, microrregiaoId: mesoId });
        }
      });

      const lista = Array.from(microMap.values()).sort((a, b) =>
        a.nome.localeCompare(b.nome)
      );

      setMicroRegioes(lista);
    };

    if (Array.isArray(todosOsClientes)) {
      fetchMicroRegioes(todosOsClientes);
    }
  }, [todosOsClientes]);

  const optionMicroRegioes = useMemo(() => {
    return prepareForOptions(microRegioes, ["nome"], "microrregiaoId");
  }, [microRegioes]);

function onChangeMicroRegiao(e) {
  setOnMicroRegiao(!!e?.value);
  microRegiaoSelect.upDateValue(e?.value);
  microRegiaoSelect.upDateDefaultValue(e || "");
  setSelectMicro(e);

  if (salvarLocalStorage && chave && todosOsClientes.length > 0) {
    const anterior = localStorage.getItem(chave);
    if (anterior) {
      const anteriorObj = JSON.parse(anterior);
      if (anteriorObj?.value !== e?.value) {
        localStorage.removeItem("select-carteira-cidade");
      }
    }
    localStorage.setItem(chave, JSON.stringify(e));
  }

  setMicroRegiao(e?.value || "");
}

  useEffect(() => {
    if(salvarLocalStorage && !restoredMicroRef.current){
      const microSalva = localStorage.getItem(chave);

      if (microSalva) {
        const microObj = JSON.parse(microSalva);
        setMicroRegiao(microObj.value);
        onChangeMicroRegiao(microObj);

      }
      restoredMicroRef.current = true;
    }
  }, [salvarLocalStorage, chave])
  function searchMicroByNome(nome) {
    return microRegioes.find((m) => m.nome === nome);
  }

  function CleanForFilter(option) {
    onChangeMicroRegiao(option);
    if ((!option || !option.value) && chave) {
      localStorage.removeItem(chave);
    }
  }
  return {
    selectMicro,
    microRegioes,
    optionMicroRegioes,
    microRegiao,
    onMicroRegiao,
    microRegiaoSelect,
    onChangeMicroRegiao,
    searchMicroByNome,
    CleanForFilter,
  };
};

export default useTodasMicroRegioes;
